import { call, delay, put, take, race } from "redux-saga/effects";
import * as ACTIONS from "../actions";

import { functions } from "../firebase/firebase";
import * as UTIL from "./util";

function* fetchRoute(action) {
  while (true) {
    try {
      yield put({
        type: ACTIONS.UPDATE_DATA_ASPECT,
        aspect: "pollingData",
        payload: true
      });

      const fetchRoute = functions.httpsCallable("fetchRoute");

      const data = yield fetchRoute({
        api: action.api,
        role: action.role,
        route: ""
      }).then(result => {
        return JSON.parse(result.data);
      });

      const alarms = yield fetchRoute({ route: "alarms" }).then(result => {
        return JSON.parse(result.data);
      });

      const normalizedData = UTIL.dataNormalizer(data);
      const organizedData = UTIL.dataOrganizer(data);

      yield put({
        type: ACTIONS.UPDATE_DATA_ASPECT,
        aspect: "data",
        payload: normalizedData
      });
      yield put({
        type: ACTIONS.UPDATE_DATA_ASPECT,
        aspect: "organizedData",
        payload: { ...organizedData, ...alarms }
      });
      yield put({
        type: ACTIONS.UPDATE_DATA_ASPECT,
        aspect: "pollingData",
        payload: false
      });

      yield delay(10000);
    } catch (e) {
      yield put({ type: ACTIONS.POLLING_FAILURE, message: e.message });
      yield put({ type: ACTIONS.STOP_POLLING });
    }
  }
}

function* watchPollSaga() {
  while (true) {
    const data = yield take(ACTIONS.START_POLLING);
    if (data.pause) {
      yield delay(15000);
    }

    yield race([call(fetchRoute, data), take(ACTIONS.STOP_POLLING)]);
  }
}

export default function* pollSaga() {
  yield watchPollSaga();
}
